<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :items="items"
      search_route="/coupon/add"
      search_title="اضافه برومو كود جديد"
      icon="fa-plus"
      v-if="helper_hasPermission('add')"
    />
    <!-- End Breadcrumb -->
    <main-filter
      @getResult="setRows"
      dateStart
      dateEnd
      startAt
      code
      :withSearch="false"
    />
    <MainLoader v-if="loading"></MainLoader>

    <div class="fadeIn" v-else>
      <!-- Start Main Section -->

      <main class="magic-table-wrapper">
        <v-data-table
          class="thumb strip"
          :headers="headers"
          :items="rows"
          :search="search"
          :loading="loading"
          :loading-text="$t('table.loadingData')"
          item-key="id"
          :items-per-page="paginations.items_per_page"
          hide-default-footer
        >
          <!-- ================== You Can use any slots you want ================== -->
          <!-- Select no data State -->

          <template v-slot:no-data>
            {{ $t("table.noData") }}
          </template>

          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>

          <!-- Start:: Users Routes -->

          <!-- <template v-slot:[`item.image`]="{ item }">
            <div class="image">
              <v-badge
                color="success"
                :content="item.applly_coupon_on"
                inline
              ></v-badge>
              <img :src="item.image" alt="" @click="show_model_1" />
            </div>
          </template> -->

          <template v-slot:[`item.coupon_type`]="{ item }">
            <span>
              {{ item.coupon_type == "meal" ? "وجبة" : "توصيل" }}
            </span>
          </template>
          <template v-slot:[`item.discount_type`]="{ item }">
            <span>
              {{ item.discount_type == "amount" ? "قيمة" : "نسبة" }}
            </span>
          </template>
          <template v-slot:[`item.is_active`]="{ item }">
            <span class="status" :class="item.is_active ? 'paid' : 'unpaid'">
              {{ item.is_active ? "فعال" : "غير فعال" }}
            </span>
          </template>
          <template v-slot:[`item.min_purchase`]="{ item }">
            <span>{{
              item.min_purchase != null ? item.min_purchase : "0"
            }}</span>
          </template>
          <template v-slot:[`item.max_discount`]="{ item }">
            <span
              v-if="item.max_discount == 0 || item.max_discount == null"
              class="text-muted"
            >
              {{ lang == "ar" ? "بلا حد أقصى" : "No cap" }}
            </span>
            <span v-else>{{ item.max_discount }}</span>
          </template>
          <template v-slot:[`item.discound`]="{ item }">
            <div class="card-table border-0">
              <div class="details p-0">
                <h4>
                  <span>قيمه الخصم:</span>
                  {{ item.discount_amount }}
                  {{ item.discount_type == "percentage" ? "%" : "" }}
                </h4>

                <h4>
                  <span>اقصي عدد مستخدمين للخصم:</span>
                  {{ item.max_used_for_user }}
                </h4>
              </div>
            </div>
          </template>

          <!-- Start:: Report Reason Modal Button -->
          <template v-slot:[`item.report_reason`]="{ item }">
            <v-icon class="show" small v-if="item.report_reason">
              fal fa-eye
            </v-icon>

            <span v-else>_</span>
          </template>
          <!-- End:: Report Reason Modal Button -->

          <!-- Select actions-->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="_actions d-flex">
              <!-- <v-icon class="show" small @click="showItem(item)">
                fal fa-eye
              </v-icon> -->
              <v-icon
                v-if="helper_hasPermission('edit')"
                class="show"
                small
                @click="editItem(item)"
              >
                fal fa-edit
              </v-icon>

              <v-icon
                v-if="helper_hasPermission('delete')"
                class="delete"
                small
                @click="deleteItem(item)"
              >
                fal fa-trash
              </v-icon>
            </div>
          </template>

          <!-- ======================== Start Top Section ======================== -->
          <template v-slot:top>
            <h3 class="table-title title">عدد البرومو كود</h3>
            <!-- Delete dialog -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">
                  {{ $t("table.deletedialog.areYouSure") }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm">
                    {{ $t("table.deletedialog.ok") }}
                  </v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">
                    {{ $t("table.deletedialog.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <!-- ======================== End Top Section ======================== -->
        </v-data-table>
      </main>

      <!-- End Statistics Card-->

      <!-- Start Pagination -->
      <template>
        <div
          class="pagination_container text-center mb-5 d-flex justify-content-end"
        >
          <div class="select-pagination d-flex">
            <span class="first">{{ $t('show') }}</span>
            <v-select
              :items="[10, 25, 50, 100]"
              v-model="paginations.items_per_page"
              @change="onPerPageChange"
            ></v-select>
            <span>{{ $t('entries') }}</span>
          </div>

          <v-pagination
            color="primary"
            v-model="paginations.current_page"
            :length="paginations.last_page"
            :total-visible="5"
            @input="fetchData($event)"
          ></v-pagination>
        </div>
      </template>
    </div>
    <!-- Delete dialog -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.promo_code.title"),
          disabled: false,
          href: "/coupon/show-all",
        },
        {
          text: this.$t("breadcrumb.promo_code.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },

      // ========== Loding
      lodaing: false,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
            width: "80",
          },
          // {
          //   text: "الصوره",
          //   align: "center",
          //   value: "image",
          //   height: "80",
          //   sortable: true,
          // },

          {
            text: "الكود",
            align: "center",
            value: "code",
            sortable: true,
          },

          // {
          //   text: "نوع الكوبون",
          //   align: "center",
          //   value: "coupon_type",
          //   sortable: true,
          // },
          {
            text: "نوع الخصم",
            align: "center",
            value: "discount_type",
            sortable: true,
          },
          {
            text: "الخصم",
            align: "center",
            value: "coupon_discount",
            sortable: true,
          },
          {
            text: "الحد الأدنى للشراء",
            align: "center",
            value: "min_purchase",
            sortable: true,
          },
          {
            text: "الحد الأقصى للخصم",
            align: "center",
            value: "max_discount",
            sortable: true,
          },
          {
            text: "مرات الاستخدام",
            align: "center",
            value: "number_of_use",
            sortable: true,
          },
          {
            text: "عدد المستخدمين",
            align: "center",
            value: "users_use_count",
            sortable: true,
          },
          // {
          //   text: "تاريخ الانشاء",
          //   align: "start",
          //   value: "created_at",
          //   sortable: true,
          // },
          {
            text: "يبدأ في",
            align: "start",
            value: "start_at",
            sortable: true,
          },
          {
            text: "ينتهي في",
            align: "start",
            value: "expired_at",
            sortable: true,
          },
          {
            text: "الاجراءات",
            align: "start",
            value: "actions",
            sortable: true,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
            width: "80",
          },
          {
            text: "Code",
            align: "center",
            value: "code",
            sortable: true,
          },
          {
            text: "Discount Type",
            align: "center",
            value: "discount_type",
            sortable: true,
          },
          {
            text: "Discount",
            align: "center",
            value: "coupon_discount",
            sortable: true,
          },
          {
            text: "Minimum Purchase",
            align: "center",
            value: "min_purchase",
            sortable: true,
          },
          {
            text: "Maximum Discount",
            align: "center",
            value: "max_discount",
            sortable: true,
          },
          {
            text: "Number of Use",
            align: "center",
            value: "number_of_use",
            sortable: true,
          },
          {
            text: "Users Count",
            align: "center",
            value: "users_use_count",
            sortable: true,
          },
          {
            text: "Starts At",
            align: "start",
            value: "start_at",
            sortable: true,
          },
          {
            text: "Expires At",
            align: "start",
            value: "expired_at",
            sortable: true,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
  },

  methods: {
    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/coupon/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/coupon/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/coupon/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `coupon/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    deleteSelected() {
      this.dialogDelete_selected = true;
    },
    deleteSelectedConfirm() {
      this.$axios({
        method: "POST",
        url: `coupon/deleteAll`,
        data: { ids: this.selected.map((item) => item.id) },
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return !this.selected.filter((obj) => obj.id == item.id).length > 0;
          });
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // Set Rows
    setRows(e) {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "coupon",
        params: {
          page: this.paginations.current_page,
          per_page: this.paginations.items_per_page,
          start_at: e?.dateStart ? e.dateStart : "",
          end_at: e?.dateEnd ? e.dateEnd : "",
          code: e?.code ? e.code : "",
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;
          this.statisticsItem.number = res.data.meta.total;
          this.rows = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
    onPerPageChange() {
      this.paginations.current_page = 1;
      this.setRows();
    },
  },
  created() {
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },

  // ======= hooks
};
</script>

<style lang="scss" scoped>
.image {
  width: 120px;
  position: relative;
  > span {
    position: absolute;
    top: -10px;
    right: -10px;
  }
  img {
    width: 100%;
    height: 80px;
    object-fit: cover;
  }
}
</style>
